<template>
  <ui-dialog
    :show="isOpen"
    persistent
    scrollable
    :closable="false"
    max-width="650"
    @input="close"
  >
    <template #header>
      <h3>
        {{ $t("message.externalChanges.protect.infoDialog.title") }}
        <v-icon color="teal">icon-status-success</v-icon>
      </h3>
    </template>
    <template #default>
      <p>
        {{ $t("message.externalChanges.protect.infoDialog.textContentFirst") }}
      </p>
    </template>

    <template #actions>
      <div class="d-flex justify-end w-100">
        <ui-button color="primary" outlined @click="close">{{
          $t("message.common.ok")
        }}</ui-button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "ProtectInfoDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
